import { Toaster as Sonner } from "sonner"

const Toaster = ({
  ...props
}) => {
  return (
    (<Sonner
      theme="dark"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-slate-800/95 group-[.toaster]:text-white group-[.toaster]:border-slate-700/50 group-[.toaster]:shadow-xl group-[.toaster]:backdrop-blur-sm",
          description: "group-[.toast]:text-slate-300",
          actionButton:
            "group-[.toast]:bg-green-500 group-[.toast]:text-white group-[.toast]:hover:bg-green-600",
          cancelButton:
            "group-[.toast]:bg-slate-700/50 group-[.toast]:text-slate-300 group-[.toast]:hover:bg-slate-600/50",
          error: "group-[.toast]:bg-red-500/20 group-[.toast]:border-red-500/30 group-[.toast]:text-red-400",
          success: "group-[.toast]:bg-green-500/20 group-[.toast]:border-green-500/30 group-[.toast]:text-green-400",
          loading: "group-[.toast]:bg-green-500/20 group-[.toast]:border-green-500/30 group-[.toast]:text-green-400",
        },
      }}
      {...props} />)
  );
}

export { Toaster }
